import firebase from 'firebase/app'

import React, { FunctionComponent } from 'react'

import { WindowLocation } from '@reach/router'

import DefaultLayout from '../layouts/index'

import FirebaseLoadable from '../components/firebase-loadable'
import SignOut from '../components/sign-out'

type SignOutPageProps = {
  location: WindowLocation
}

const SignOutPage: FunctionComponent<SignOutPageProps> = ({ location }) => {
  let resolver
  let rejecter
  const firebasePromise = new Promise<firebase.FirebaseApp>(
    (resolve, reject) => {
      resolver = resolve
      rejecter = reject
    },
  )
  const [firebaseApp, setFirebaseApp] = React.useState<
    firebase.FirebaseApp | undefined
  >(undefined)

  firebasePromise
    .then((fbApp: firebase.FirebaseApp) => {
      setFirebaseApp(fbApp)
    })
    .catch((reason) => {
      console.error(reason)
    })

  return (
    <DefaultLayout
      suppressSignOutLink={true}
      location={location}
      firebase={firebaseApp}>
      <FirebaseLoadable resolver={resolver} rejecter={rejecter} />
      {!firebaseApp ? (
        <div>Initializing Firebase...</div>
      ) : (
        <SignOut location={location} firebase={firebaseApp} />
      )}
    </DefaultLayout>
  )
}

export default SignOutPage
